/**
 * Donation Form JS
 *
 * @author Red Tiki <info@redtiki.co>
 */

(function($) {
    $(document).ready(function() {
        //$('.donation-option:not(.active)').find('.optionset input[type="radio"]').prop('disabled', true);
        //$('.donation-option:not(.active)').find('.optionset').hide();

        window.donationAmount = false;

        const stYaredPage = $('.template-StYaredDonationPage').length

        $('[name="SponsorChild"]').on('change', function() {
            if ($(this).prop('checked') == true) {
                if (!stYaredPage) {
                    if (window.donationAmount === false)
                    {
                        window.donationAmount = $('#TotemForm_Form_Amount').val();
                    }
                    $('#TotemForm_Form_Amount').val($(this).val());
                    var amount = $('<input id="sponsor-amount" type="hidden" name="Amount" />');
                    amount.val($(this).val());
                    $('#sponsor-amount').replaceWith(amount);
                    amount.appendTo('#Amount .input-group');
                } else {
                    $('#SponsorChildPopup').removeAttr('hidden');
                }
            }
        });

        $('#GeneralDonation, #DonateCommunityPrograms, #SponsorChild')
            .on('change', function() {
                if ($(this).prop('checked') == true) {
                    var $p = $(this).parents('.donation-option');

                    $p.addClass('active');
                    $p.find('.optionset input[type="radio"]').prop('disabled', false);

                    var $checkedChildren = $p.find('.optionset input:checked');

                    if ($checkedChildren.length === 0) {
                        $p.find('.optionset input[type="radio"]')
                            .first()
                            .attr({ checked: 'checked' });
                    }

                    $p.find('.optionset').slideDown();

                    $('.donation-option')
                        .not($p)
                        .removeClass('active')
                        .find('.optionset')
                        .slideUp()
                        .find('.optionset input[type="radio"]')
                        .prop({
                            disabled: true,
                            checked: false
                        });

                    if ($(this).val() == 2) {
                        if (!stYaredPage) {
                            $('#TotemForm_Form_Amount').attr('disabled','disabled');
                        }
                        $('[name="SponsorChild"]').trigger('change');
                    } else {
                        if (window.donationAmount !== false) {
                            $('#TotemForm_Form_Amount').val(window.donationAmount);
                            window.donationAmount = false;
                        }
                        if (!stYaredPage) {
                            $('#TotemForm_Form_Amount').removeAttr('disabled');
                            $('#sponsor-amount').remove();
                        } else {
                            $('#SponsorChildPopup').attr('hidden', 'hidden');
                        }
                    }
                }
            })
            .trigger('change');

        $('input[name="Renewal"]')
            .on('change', function() {
                if (this.checked) {
                    $('input[name="SponsorChild"]').prop('checked', false);
                    $('#ChildName').slideDown();

                    document.querySelector('input[name="Type"]').checked = true;
                } else {
                    $('input[name="SponsorChild"]').prop('checked', true);
                    $('#ChildName').slideUp();
                }
            })
            .trigger('change');

        $('input[name="SponsorChild"]')
            .on('change', function() {
                if (this.checked) {
                    $('input[name="Renewal"]').prop('checked', false);
                    $('#ChildName').slideUp();

                    document.querySelector('input[name="Type"]').checked = true;
                }
            })
            .trigger('change');

        $('#TotemForm_Form_action_processDonation').click(function(e) {
            $('[required]').each(function(e) {
                $(this).removeClass('invalid');
            });
        });

        $('[required]').on('invalid', function(e) {
            $(this).addClass('invalid');
        });
    });
})(jQuery);
